import {
  Service
} from '../service.js'
import {
  env
} from '../env.js'

class UsuarioService extends Service {
  constructor() {
    super();

    this.url = env.url + "usuarios";
  }

  /**
   * Lista usuários por tipo com informações completas
   * @param {number} tipo - Tipo do usuário (tipoUsuarioEnum.OPERADOR.getId() ou tipoUsuarioEnum.CLIENTE.getId())
   * @returns {Promise<Array<{value: number, label: string, idDoResponsavelDoHistorico: Array, idsDepartamentosResponsavel: Array, idsDepartamentos: Array, acessaTodosDepartamentos: boolean}>>}
   */
  async listarUsuariosPorTipo(tipo) {
    const primeiraRequisicao = await super.get(`${this.url}?tipo=${tipo}&status=1&limit=1`);
    const total = primeiraRequisicao.totalDeItens;
    const usuarios = await super.get(`${this.url}?tipo=${tipo}&status=1&limit=${total}`);
    
    return usuarios.data.map((element) => ({
      value: element.id,
      label: element.nome,
      idDoResponsavelDoHistorico: element.idDoResponsavelDoHistorico,
      idsDepartamentosResponsavel: element.idsDepartamentosResponsavel,
      idsDepartamentos: element.idsDepartamentos,
      acessaTodosDepartamentos: element.acessaTodosDepartamentos
    }));
  }

  /**
   * Lista responsáveis ativos
   * @deprecated Use listarUsuariosPorTipo(tipoUsuarioEnum.OPERADOR.getId()) ao invés deste método.
   * Este método será removido em versões futuras.
   * Em alterações futuras, migre para o novo método genérico.
   * @returns {Promise<Array>}
   */
  async listarResponsaveis(usuarioAgenteIA = false) {
    const responsaveis = await super.get(`${this.url}?tipo=1&status=1&usuarioAgenteIA=${usuarioAgenteIA}`);
    const total = responsaveis.totalDeItens;
    const responsaveis_data = await super.get(
      `${env.url}usuarios?tipo=1&status=1&limit=${total}&usuarioAgenteIA=${usuarioAgenteIA}`);
    return responsaveis_data.data.map((element) => {
      return {
        value: element.id,
        label: element.nome,
        idDoResponsavelDoHistorico: element.idDoResponsavelDoHistorico,
        idsDepartamentosResponsavel: element.idsDepartamentosResponsavel,
        idsDepartamentos: element.idsDepartamentos,
        acessaTodosDepartamentos: element.acessaTodosDepartamentos,
        agenteIaId: element.agenteIaId
      };
    });
  }
  async getResponsavel(idResponsavel) {
    const responsavel = await super.get(`${this.url}/${idResponsavel}`);
    return responsavel;
  }

  async getResponsavelByProcesso(processoId) {

    try {
      const responsavel = await super.get(`${this.url}/processo/${Number(processoId)}`);
      return responsavel;
    } catch(e) {
      console.warn(e)
    }

  }

  async getResponsavelByFase(faseId) {

    try {
      const responsavel = await super.get(`${this.url}/fase/${Number(faseId)}`);
      return responsavel;
    } catch(e) {
      console.warn(e)
    }

  }
}

export const usuarioService = new UsuarioService()
